import React from 'react';
import './style.scss';
import Button from '../../../../../components/molecules/buttons';
import {
  ArrowLeft, Delete, Driver, Pencil,
} from '../../../../../components/atoms/icons';
import RenderTable from './RenderTable';
import useIdRoute from './hooks';
import { firstLetterCapitalized } from '../../../../../components/atoms/func';
import { successUpdateMsg } from '../../../../../components/atoms/const';
import Modal from '../../../../../components/organisms/modals';

function DetailRoute(): React.ReactElement {
  const {
    onNavigateBack, onNavigateEdit, data, deleteLoading,
    handleDelete, result, onAfterResult, resData, onNavigateRowEdit,
    onDeleteRoute, onAfterDeleteRoute, resultDeleteRoute, deleteRouteLoading,
  } = useIdRoute();

  const renderModalBody = () => {
    if (!resultDeleteRoute) return 'Are you sure? Do you want to delete this route';
    return successUpdateMsg.SUCCESS_DELETE_ROUTE_MSG;
  };

  return (
    <div className="p-4 px-xl-5">
      <div className="d-flex justify-content-between" style={{ marginBottom: '35px' }}>
        <div className="d-flex align-items-start">
          <button
            onClick={onNavigateBack}
            type="button"
            className="border-0 bg-transparent"
            style={{ marginTop: '8px' }}
          >
            <ArrowLeft />
          </button>
          <div className="ms-3">
            <h4 className="fw-bold mt-2 mb-3">
              {firstLetterCapitalized(resData?.name ?? 'Unknown')}
            </h4>
            <div className="d-flex fz-14">
              <Driver width={23} />
              <span className="text-secondary ms-2">Driver:&nbsp;</span>
              <span>{firstLetterCapitalized(resData?.user ? resData.user.firstname + resData.user.lastname : 'Unknown')}</span>
            </div>
          </div>
        </div>
        <div className="d-flex mt-1">
          <div className="me-3">
            <Button.CircleIcon
              id="editRoute"
              icon={<Pencil width={16} color="white" />}
              type="button"
              onClick={onNavigateEdit}
              isButton
            />
          </div>
          <Modal.Default
            cancelLabel="No"
            submitLabel="Yes"
            title="Delete Route"
            body={renderModalBody()}
            onSubmit={onDeleteRoute}
            dialogClassName="custom-modal-width"
            isLoading={deleteRouteLoading}
            result={resultDeleteRoute}
            onAfterResult={onAfterDeleteRoute}
          >
            <Button.CircleIcon id="circleDeleteRoute" icon={<Delete width={15} color="white" />} />
          </Modal.Default>
        </div>
      </div>
      <RenderTable
        data={data}
        deleteLoading={deleteLoading}
        handleDelete={handleDelete}
        result={result}
        onAfterResult={onAfterResult}
        onNavigateRowEdit={onNavigateRowEdit}
      />
    </div>
  );
}

export default DetailRoute;
